import Vue from "vue";
import Vuex from "vuex";
import feed from "./feed";
import queue from "./queue";
import queueToastConnector from "./queue-toast";
import toasts from "./toasts";

Vue.use(Vuex);

export default new Vuex.Store({
  mutations: {},
  actions: {},
  modules: { feed, queue, toasts },
  plugins: [queueToastConnector("queue", "toasts")]
});
